<template>
    <form>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-text-field v-model="profilEdit.first_name" :error-messages="firstNameErrors"
                              :counter="30" filled label="Prénom" required
                              @input="$v.profilEdit.first_name.$touch()"
                              @blur="$v.profilEdit.first_name.$touch()" />
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-text-field v-model="profilEdit.last_name" :error-messages="lastNameErrors"
                              :counter="30" filled label="Nom" required
                              @input="$v.profilEdit.last_name.$touch()"
                              @blur="$v.profilEdit.last_name.$touch()" />
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-text-field v-model="profilEdit.phone" :error-messages="phoneErrors"
                              label="Téléphone" filled required
                              @input="$v.profilEdit.phone.$touch()"
                              @blur="$v.profilEdit.phone.$touch()" />
            </v-flex>
            <v-flex xs12 sm6>
                <v-text-field v-model="profilEdit.email" filled label="E-mail" disabled />
            </v-flex>
            <v-flex xs12 sm6>
                <v-text-field v-model="profilEdit.company" :error-messages="companyErrors"
                              :counter="50" filled label="Entreprise" required
                              @input="$v.profilEdit.company.$touch()"
                              @blur="$v.profilEdit.company.$touch()" />
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-layout v-if="editProfil" class="custom_layout_btn">
                    <v-flex xs12>
                        <v-btn class="custom_btn_position custom_btn_color_red"
                               @click="clear">
                            Annuler
                        </v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn class="custom_btn_position custom_btn_color_blue"
                               @click="submit">
                            Valider
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </form>
</template>

<script>
    import { maxLength, minLength, numeric, required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'AccountProfil',
        mixins: [validationMixin],
        validations: {
            profilEdit: {
                first_name: { required, maxLength: maxLength(30) },
                last_name: { required, maxLength: maxLength(30) },
                phone: { required, numeric, maxLength: maxLength(10), minLength: minLength(10) },
                company: { required }
            }
        },
        data: () => ({
            profilEdit: {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                company: ''
            },
            editProfil: false,
            panel: ['true']
        }),
        computed: {
            ...mapGetters('app', ['profil']),
            firstNameErrors () {
                const errors = [];
                if (!this.$v.profilEdit.first_name.$dirty) return errors;
                !this.$v.profilEdit.first_name.maxLength && errors.push('FirstName must be at most 30 characters long');
                !this.$v.profilEdit.first_name.required && errors.push('FirstName is required.');
                return errors;
            },
            lastNameErrors () {
                const errors = [];
                if (!this.$v.profilEdit.last_name.$dirty) return errors;
                !this.$v.profilEdit.last_name.maxLength && errors.push('LastName must be at most 30 characters long');
                !this.$v.profilEdit.last_name.required && errors.push('LastName is required.');
                return errors;
            },
            phoneErrors () {
                const errors = [];
                let phone = this.$v.profilEdit.phone;
                if (!phone.$dirty) return errors;
                (!phone.numeric || !phone.maxLength || !phone.minLength) && errors.push('Must be valid phone');
                !phone.required && errors.push('Phone is required');
                return errors;
            },
            companyErrors () {
                const errors = [];
                if (!this.$v.profilEdit.company.$dirty) return errors;
                !this.$v.profilEdit.company.required && errors.push('Company is required');
                return errors;
            }
        },
        watch: {
            profil: function (newValue) {
                this.profilEdit = JSON.parse(JSON.stringify(newValue));
            },
            'profilEdit.first_name': function () {
                this.editProfil = this.equalsProfil(this.profilEdit, this.profil);
            },
            'profilEdit.last_name': function () {
                this.editProfil = this.equalsProfil(this.profilEdit, this.profil);
            },
            'profilEdit.phone': function () {
                this.editProfil = this.equalsProfil(this.profilEdit, this.profil);
            },
            'profilEdit.company': function () {
                this.editProfil = this.equalsProfil(this.profilEdit, this.profil);
            }
        },
        created () {
            this.profilEdit = JSON.parse(JSON.stringify(this.profil));
        },
        methods: {
            ...mapActions('app', ['updateProfil', 'showOverlay', 'hideOverlay']),
            submit () {
                this.$v.profilEdit.$touch();
                if (!this.$v.profilEdit.$error) {
                    this.updateProfil(this.profilEdit).then(() => {
                        this.$toasted.success('Votre profil a bien été modifié');
                        this.editProfil = false;
                    }, (err) => {
                        this.$toasted.error(err);
                    });
                }
            },
            clear () {
                this.editProfil = false;
                this.profilEdit = JSON.parse(JSON.stringify(this.profil));
            },
            equalsProfil: function (profil1, profil2) {
                return JSON.stringify(profil1) !== JSON.stringify(profil2);
            }
        }
    };
</script>

<style lang="scss" scoped>
    //* VUETIFY *//
    .theme--light.v-expansion-panel .v-expansion-panel__container, .v-expansion-panel__body > .v-card {
        border-radius: 10px !important;
    }

    .v-expansion-panel__container .v-expansion-panel__header {
        min-height: 100px !important;
        font-size: 1.5em !important;
        font-weight: 500 !important;
    }

    .v-text-field.v-text-field--enclosed {
        padding: 10px 20px 10px 20px;
    }

    #profil_expansion_panel {
        margin-left: 15px;
        margin-right: 15px;
        width: calc(100% - 30px);
    }

    .custom_layout_btn {
        padding: 20px 20px 0px 20px !important;
        margin-bottom: 20px;
    }
</style>
